import { Swiper } from 'swiper'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

Swiper.use([Pagination])
Swiper.use([Autoplay])
Swiper.use([Navigation])

export default () => ({
    carousel: null,

    init() {
        this.carousel = new Swiper('.swiper-testimonial-carousel-instance', {
            slidesPerView: 1,
            spaceBetween: 26,
            speed: 1250,
            effect: "fade",
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        })
    },
})
